/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalendarioLavoriResponseDTO
 */
export interface CalendarioLavoriResponseDTO {
    /**
     * 
     * @type {Date}
     * @memberof CalendarioLavoriResponseDTO
     */
    data?: Date;
    /**
     * 
     * @type {number}
     * @memberof CalendarioLavoriResponseDTO
     */
    ore?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarioLavoriResponseDTO
     */
    anomalia?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarioLavoriResponseDTO
     */
    giornoExtra?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarioLavoriResponseDTO
     */
    festivo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarioLavoriResponseDTO
     */
    hasNote?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarioLavoriResponseDTO
     */
    hasDiaria?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarioLavoriResponseDTO
     */
    allowAdd?: boolean;
}

/**
 * Check if a given object implements the CalendarioLavoriResponseDTO interface.
 */
export function instanceOfCalendarioLavoriResponseDTO(value: object): value is CalendarioLavoriResponseDTO {
    return true;
}

export function CalendarioLavoriResponseDTOFromJSON(json: any): CalendarioLavoriResponseDTO {
    return CalendarioLavoriResponseDTOFromJSONTyped(json, false);
}

export function CalendarioLavoriResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarioLavoriResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'ore': json['ore'] == null ? undefined : json['ore'],
        'anomalia': json['anomalia'] == null ? undefined : json['anomalia'],
        'giornoExtra': json['giornoExtra'] == null ? undefined : json['giornoExtra'],
        'festivo': json['festivo'] == null ? undefined : json['festivo'],
        'hasNote': json['hasNote'] == null ? undefined : json['hasNote'],
        'hasDiaria': json['hasDiaria'] == null ? undefined : json['hasDiaria'],
        'allowAdd': json['allowAdd'] == null ? undefined : json['allowAdd'],
    };
}

export function CalendarioLavoriResponseDTOToJSON(json: any): CalendarioLavoriResponseDTO {
    return CalendarioLavoriResponseDTOToJSONTyped(json, false);
}

export function CalendarioLavoriResponseDTOToJSONTyped(value?: CalendarioLavoriResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'ore': value['ore'],
        'anomalia': value['anomalia'],
        'giornoExtra': value['giornoExtra'],
        'festivo': value['festivo'],
        'hasNote': value['hasNote'],
        'hasDiaria': value['hasDiaria'],
        'allowAdd': value['allowAdd'],
    };
}

